export default {
    formatDate(timestamp) {
        let frontdate = ''
        if (moment(timestamp, "YYYY-MM-DD HH:mm:ss").format('YYYYMMDD') == moment().format('YYYYMMDD')) {
            frontdate = '今天'
        } else if (moment(timestamp, "YYYY-MM-DD HH:mm:ss").format('YYYYMMDD') == moment().subtract(1, 'days').format('YYYYMMDD')) {
            frontdate = '昨天'
        } else if (moment(timestamp, "YYYY-MM-DD HH:mm:ss").format('YYYY') == moment().format('YYYY')) {
            frontdate = moment(timestamp, "YYYY-MM-DD HH:mm:ss").format('MM月DD日')
        } else {
            frontdate = moment(timestamp, "YYYY-MM-DD HH:mm:ss").format('YYYY年MM月DD日')
        }

        let behinddate = moment(timestamp, "YYYY-MM-DD HH:mm:ss").format('HH:mm')
        return `${frontdate} ${behinddate}`
    }
}